import { Injectable, inject } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { EligibleEligibilityEventState, EligibleEligibilityEventStore } from './eligible-eligibility-event.store';

@Injectable({
  providedIn: 'root',
})
export class EligibleEligibilityEventQuery extends QueryEntity<EligibleEligibilityEventState> {
  protected store: EligibleEligibilityEventStore;

  constructor() {
    const store = inject(EligibleEligibilityEventStore);

    super(store);

    this.store = store;
  }
}
